import styled from 'styled-components';

export const ProductContainer = styled.div`
  padding-bottom: 24px;
  margin: 0 6em;
  position: relative;
  .heading {
    opacity: 0.8;
    font-size: 19px;
    font-weight: 600;
    text-align: left;
    color: #000;
    text-align: center;
    margin-bottom: 27px;
  }
  @media (max-width: 720px) {
    margin: 0;
  }
`;

export const ProductCardCover = styled.div`
  margin: 0 7px;
  &:first-child {
    margin-left: 16px;
  }
  &:last-child {
    margin-right: 16px;
  }

  border: solid 1px #dadada;
  padding-right: 0px;
  cursor: default;
  flex-basis: 20%;
  @media (max-width: 720px) {
    flex-basis: 42%;
  }
  overflow: hidden;
  flex-shrink: 0;
  .productName {
    overflow: hidden;
    padding: 9px 0px 0px;
    width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    opacity: 0.87;
    font-size: 12px;
    text-align: left;
    color: #000;
  }
  .variant {
    opacity: 0.38;
    font-size: 10px;
    text-align: left;
    color: #000;
    padding-top: 7px;
    height: 20px;
  }
  cursor: pointer;

  @media (max-width: 720px) {
    cursor: none;
  }
`;

export const ProductImageContainer = styled.div`
  width: 100%;
  padding-top: 100%;
  position: relative;
`;

export const ProductFlex = styled.div`
  display: flex;
  width: 100%;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  .lowOpacity {
    opacity: 0.5;
  }
`;
export const ProductText = styled.div`
  padding-left: 9px;
`;
